import http from "../../../http-common"
class RegulatoryFocusLatestFeaturesServices {
    getAllRegulatoryFocusLatestFeatures() {
        return http.get('/regulatory-focus/latest-features')
    }
}

export default new RegulatoryFocusLatestFeaturesServices();